import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import welcomeCss from "./Welcome.module.css";
import welcome1 from "../../asset/Image/welcome1.jpg";
import welcome from "../../asset/Image/welcome5.jpg";
import welcome3 from "../../asset/Image/welcome6.jpg";
import bulb from "../../asset/Image/bulb.png";
import bomb from "../../asset/Image/bomb.png";
import book from "../../asset/Image/book.png";
import Roll from "react-reveal/Roll";
export default function Welcome() {
  return (
    <>
      <div className={`${welcomeCss.introArea} ${welcomeCss.introareatop}`}>
        <Container>
          <div className={`${welcomeCss.introInner}`}>
            <Roll top>
              <Row className="justify-content-center">
                <Col lg={6} md={6} sm={12}>
                  <div className={`${welcomeCss.sectionTitle} text-center`}>
                    <h6
                      className={`${welcomeCss.subTitle} ${welcomeCss.doubleLine}`}
                    >
                      FEATURES
                    </h6>
                    <h2 className={`${welcomeCss.title}`}>
                      An exemplary <br /> learning community
                    </h2>
                  </div>
                </Col>
              </Row>
            </Roll>
            <Roll right>
              <Row>
                <Col lg={4} md={4} sm={12}>
                  <img src={welcome1} alt="" className="img-fluid" />
                  <div className={`${welcomeCss.details} text-center`}>
                    <h5>Postgraduate</h5>
                    <p>Lorem ipsum dolor</p>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <img src={welcome} alt="" className="img-fluid" />
                  <div className={`${welcomeCss.details} text-center`}>
                    <h5>Postgraduate</h5>
                    <p>Lorem ipsum dolor</p>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <img src={welcome3} alt="" className="img-fluid" />
                  <div className={`${welcomeCss.details} text-center`}>
                    <h5>Postgraduate</h5>
                    <p>Lorem ipsum dolor</p>
                  </div>
                </Col>
              </Row>
            </Roll>
            <div className={`${welcomeCss.introfooter} ${welcomeCss.bgBase}`}>
              <Row className={`${welcomeCss.mobileRes}`}>
                <Col lg={4} md={4} sm={12}>
                  <div className={`${welcomeCss.singleListInner} `}>
                    <Row className="gap-3 align-items-center">
                      <Col lg={2} md={2} sm={2}>
                        <img src={bulb} alt="" />
                      </Col>
                      <Col lg={8} md={8} sm={8} style={{ alignSelf: "center" }}>
                        <h5 style={{ fontWeight: "700" }}>Accounting</h5>
                        <p>Lorem ipsum dolor</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <div className={`${welcomeCss.singleListInner} `}>
                    <Row className="gap-3 align-items-center">
                      <Col lg={2} md={2} sm={2}>
                        <img src={bomb} alt="" />
                      </Col>
                      <Col lg={8} md={8} sm={8} style={{ alignSelf: "center" }}>
                        <h5 style={{ fontWeight: "700" }}>Accounting</h5>
                        <p>Lorem ipsum dolor</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <div className={`${welcomeCss.singleListInner} `}>
                    <Row className="gap-3 align-items-center">
                      <Col lg={2} md={2} sm={2}>
                        <img src={book} alt="" />
                      </Col>
                      <Col lg={8} md={8} sm={8} style={{ alignSelf: "center" }}>
                        <h5 style={{ fontWeight: "700" }}>Accounting</h5>
                        <p>Lorem ipsum dolor</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
